

















































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import SensorDetailComponent from "@/components/common/parts/SensorDetailComponent.vue";
import { LPopup } from "vue2-leaflet";
import { MapMode } from "@/typescript/packages/leaflet/index";
import { SensorDiagramsInfo } from "@/typescript/pages/sensor_diagrams/types";
export { MapMode, SensorDiagramsInfo };

@Component({
  components: {
    LPopup,
    SensorDetailComponent
  }
})
export default class LeafletPopupComponent extends Vue {
  $refs!: {
    leaf_popup: LPopup;
  };
  @Prop()
  selectedSensor!: SensorDiagramsInfo;
  @Prop()
  selectableSensors!: SensorDiagramsInfo[];

  @Prop()
  mapMode!: MapMode;

  get internalSelectedSensor() {
    return this.selectedSensor;
  }

  @Emit()
  sendRemoveSensor(sensor: SensorDiagramsInfo) {
    return sensor;
  }

  @Emit()
  sendRemappingSensor(sensor: SensorDiagramsInfo) {
    return sensor;
  }
}
